"use client";
import { useEffect, useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import classes from "./OfferModal.module.css";
import { useRouter } from "next/navigation";
import DarkGreenButton from "../../UI/Buttons/DarkGreenButton";
import { X } from "react-feather";

const OfferModal = (props) => {
  const {
    author,
    showOfferModal,
    setShowOfferModal,
    setOffer,
    listing,
    offer,
    setDeliveryDetails,
  } = props;

  const ref = useRef();
  const router = useRouter();

  const [forEntireSet, setForEntireSet] = useState(true);
  const [offerInfo, setOfferInfo] = useState("");
  const [offerError, setOfferError] = useState("");

  useEffect(() => {
    if (global?.window && offerInfo) {
      localStorage.setItem("offerInfo", offerInfo);
    }
  }, [offerInfo]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (showOfferModal && ref.current && !ref.current.contains(e.target)) {
        setShowOfferModal(!showOfferModal);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showOfferModal]);

  useEffect(() => {
    let discount = listing?.store?.salesPreferences?.acceptOffers?.minimumOffer
      ? listing?.store?.salesPreferences?.acceptOffers?.minimumOffer
      : 50;

    let minimumListingPrice = listing.price * (discount / 100);
    if (offer < minimumListingPrice) {
      setOfferError(
        `Too low - max ${discount?.toFixed(0)}% discount for this item`
      );
    } else {
      setOfferError();
    }
  }, [offer, listing]);

  const sendOfferHandler = () => {
    let discount = listing?.store?.salesPreferences?.acceptOffers?.minimumOffer
      ? listing?.store?.salesPreferences?.acceptOffers?.minimumOffer
      : 50;

    let minimumListingPrice = listing.price * (discount / 100);
    if (offer < minimumListingPrice) {
      setOfferError(
        `Too low - max ${discount?.toFixed(0)}% discount for this item`
      );
      return;
    }

    setOfferError("");
    if (global?.window && forEntireSet) {
      localStorage.removeItem("offerInfo");
    }

    setDeliveryDetails();

    global?.window &&
      localStorage.setItem(
        "checkout",
        JSON.stringify([
          {
            listingPrice: offer ? offer : listing.price,
            id: listing._id,
          },
        ])
      );

    router.push(`/checkout`);
  };

  return (
    <>
      {author && (
        <Modal show={showOfferModal}>
          <X
            className={classes.closeIcon}
            strokeWidth={1}
            onClick={() => setShowOfferModal(false)}
          />

          <div ref={ref}>
            {/*This is the image card w/Carousel*/}

            <div className={classes.listingCard}>
              <h3 className={classes.modalText}>
                Current Price:{" "}
                <div className={classes.pColor}>
                  ${listing.price.toLocaleString()}
                </div>
              </h3>

              <>
                <div className={classes.padding} ref={ref}>
                  <>
                    {" "}
                    <div className={classes.offerSection}>
                      <div
                        className={
                          offer === Math.ceil(listing.price * 0.85)
                            ? classes.activeBox
                            : classes.offerBox
                        }
                        onClick={() =>
                          setOffer(Math.ceil(listing.price * 0.85))
                        }
                      >
                        <div className={classes.amount}>
                          ${Math.ceil(listing.price * 0.85).toLocaleString()}
                        </div>
                        <div
                          className={
                            offer === Math.ceil(listing.price * 0.85)
                              ? classes.percentAmountActive
                              : classes.percentAmount
                          }
                        >
                          15% off
                        </div>
                      </div>

                      <div
                        className={
                          offer === Math.ceil(listing.price * 0.9)
                            ? classes.activeBox
                            : classes.offerBox
                        }
                        onClick={() => setOffer(Math.ceil(listing.price * 0.9))}
                      >
                        <div className={classes.amount}>
                          ${Math.ceil(listing.price * 0.9).toLocaleString()}
                        </div>
                        <div
                          className={
                            offer === Math.ceil(listing.price * 0.9)
                              ? classes.percentAmountActive
                              : classes.percentAmount
                          }
                        >
                          10% off
                        </div>
                      </div>
                      <div
                        className={
                          offer === Math.ceil(listing.price * 0.95)
                            ? classes.activeBox
                            : classes.offerBox
                        }
                        onClick={() =>
                          setOffer(Math.ceil(listing.price * 0.95))
                        }
                      >
                        <div className={classes.amount}>
                          ${Math.ceil(listing.price * 0.95).toLocaleString()}
                        </div>
                        <div
                          className={
                            offer === Math.ceil(listing.price * 0.95)
                              ? classes.percentAmountActive
                              : classes.percentAmount
                          }
                        >
                          5% off
                        </div>
                      </div>
                    </div>
                    <div className={classes.separator}>
                      <div className={classes.line}></div>
                      <div className={classes.separatorText}>or</div>
                      <div className={classes.line}></div>
                    </div>
                    <div className={classes.inputDiv}>
                      <div className={classes.inputWrapper}>
                        <input
                          required
                          type="number"
                          min="1"
                          prefix="$"
                          // max={listing.price}
                          defaultValue={Math.ceil(listing.price * 0.85)}
                          value={offer}
                          className={classes.offerInput}
                          onChange={(e) => setOffer(e.target.value)}
                        />
                        <div className={classes.dollarSign}>$</div>
                      </div>
                    </div>
                    <div className={classes.errors}>
                      {offerError && offerError}
                    </div>
                    <h3 className={classes.yourOffer}>
                      Your Offer:{" "}
                      <div className={classes.textGreen}>
                        ${offer.toLocaleString()}
                      </div>
                    </h3>
                    <div className={classes.checkBox}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="This offer is for the entire item/set"
                          checked={forEntireSet}
                          onChange={() => setForEntireSet(!forEntireSet)}
                          id="forEntireSet"
                        />
                      </Form.Group>
                    </div>
                    {!forEntireSet && (
                      <div className={classes.textArea}>
                        <Form.Group>
                          <Form.Control
                            rows={2}
                            as="textarea"
                            type="text-box"
                            name="offerInfo"
                            placeholder="ex. this offer is only for the chairs in the dining set"
                            onChange={(e) => setOfferInfo(e.target.value)}
                            value={offerInfo}
                          />
                        </Form.Group>
                      </div>
                    )}
                    <>
                      <DarkGreenButton
                        className={classes.submitButton}
                        onClick={sendOfferHandler}
                      >
                        Next
                      </DarkGreenButton>
                    </>
                    <div className={classes.offerInfo}>
                      <b>All offers expire after 48 hours.</b>
                      {/* <br />
											If the seller accepts your offer, payment will be
											processed. */}
                    </div>
                  </>
                </div>
              </>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default OfferModal;
